const STATUS_META = {
  processing: { label: 'Processing', pillClass: 'processingPill' },
  refunded: { label: 'Refunded', pillClass: 'collectedPill' },
  failed: { label: 'Failed', pillClass: 'cancelledPill' }
}

export function getRefundStatusMeta(status) {
  return (
    STATUS_META[status] || {
      label: status || 'Unknown',
      pillClass: 'unknownPill'
    }
  )
}

const TYPE_LABEL = { full: 'Full refund', partial: 'Partial refund' }

export function getRefundTypeLabel(type) {
  return TYPE_LABEL[type] || type || 'N/A'
}

// Cancellation and rejection refunds carry no user: the system raised them.
export function getRefundInitiator(refund) {
  return refund.initiated_by_name || refund.initiated_by || 'System'
}
